<template>
  <v-card flat class="ch-post__meta" width="100%">
    <v-card-subtitle class="px-0 py-2">
      <v-icon small color="primary" class="mr-2 d-none d-sm-inline-flex">mdi-clock-outline</v-icon>
      <span v-html="postedOn"></span> <span class="secondary--text mx-1"> | </span>
      <span v-html="postedBy"></span> <span class="secondary--text mx-1"> | </span>
      <a :href="category.link" v-html="category.name"></a>
    </v-card-subtitle>
  </v-card>
</template>

<script>
  export default {
    name: 'PostMetaRow',

    props: ['category', 'posted-on', 'posted-by']
  }
</script>

<style lang="sass">
  .ch-post__meta a
    text-decoration: none
</style>